require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./works-2019-07-01-to-hold.json") })
        }
      }, "path---works-2019-07-01-to-hold");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---works-2019-07-01-to-hold!./.cache/json/works-2019-07-01-to-hold.json
// module id = 440
// module chunks = 231608221292675